import { render, staticRenderFns } from "./Volunteers.vue?vue&type=template&id=f0fa2b64&scoped=true"
import script from "./Volunteers.vue?vue&type=script&lang=js"
export * from "./Volunteers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fa2b64",
  null
  
)

export default component.exports